export function wrapTextNodes(node) {
  if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
    const parent = node.parentNode;
    const textArray = node.textContent.split('');
    let combinedText = [];

    textArray.forEach((char, index) => {
      // 現在の文字が句点または読点である場合
      if (char === '。' || char === '、' || char === '.') {
        // 前の文字と連結
        if (combinedText.length > 0) {
          combinedText[combinedText.length - 1] += char;
        }
      } else {
        combinedText.push(char);
      }
    });

    combinedText.forEach(char => {
      const span = document.createElement('span');
      span.classList.add('letter');
      span.textContent = char;
      parent.insertBefore(span, node);
    });

    parent.removeChild(node);
  } else {
    node.childNodes.forEach(child => wrapTextNodes(child));
  }
}